import { Box, Checkbox, FormHelperText } from 'node_modules/@mui/material/index';
import React from 'react';
import FormControl from './formControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';

const MuiCheckBox = (props) => {
  const { checked, value, handleChange, name, helperText, fullWidth, label } = props;
  return (
    <FormControl key={`key${name}`} error={helperText ? true : false} fullWidth={fullWidth}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            value={value}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={label}
      />
      <Box>{helperText && <FormHelperText>{helperText}</FormHelperText>}</Box>
    </FormControl>
  );
};

MuiCheckBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  checked: PropTypes.bool,
};

export default MuiCheckBox;
